/**
 * Layout
 */

import {getRootVar} from '../../shared/js/utils';

import SelectorEngine from '../../shared/js/dom/selector-engine';

import header     from './header/header';
import navigation from './navigation/navigation';
import footer     from './footer/footer';
import search     from './search/search';
import emergency  from './emergency/emergency';
import social  from './social/social';

import Jumplist from '../../shared/components/jumplist/jumplist';

/**
 * Sprungliste die einer Seite ´global´ hinzugefügt wurde.
 */
const pageJumplist = () => {
	const originalDocTitle = document.title;
	const originalDocUrl   = location.href;
	const pageJumplist     = SelectorEngine.findOne('#page-jumplist');

	if(pageJumplist) {
		const apiPageJumplist = Jumplist.init(pageJumplist, {
			windowMode: true, // Diese Jumplist ´behandelt´ das Window-Objekt!
			onNavigate: (event) => {
				//
				// ´Scroll top offset´ dem Zielbereich zuweisen.
				// Somit verschwindet er nicht visuell unter der Jumplist.
				//

				const sto = parseInt(getRootVar('global-scroll-top-offset') || 0, 10);
				const jlh = pageJumplist.offsetHeight;

				event.section.style.scrollMarginTop = `${jlh + sto}px`;

				//
				// Dokumenetentitel, -URL und Historieaktualisieren.
				//

				const newDocTitle = `${originalDocTitle} (${event.link.jumplistText})`;
				const historyUrl  = location.hash ? `${originalDocUrl.split('#')[0]}${event.link.jumplistHash}` : `${location.href.split('#')[0]}${event.link.jumplistHash}`;

				// Seitentitel aktualisieren.
				document.title = newDocTitle;

				// History aktualsieren.
				history.pushState({
					section: event.section.jumplistHash,
					title  : newDocTitle
				}, '', historyUrl);
			}
		});

		if (location.hash) {
			apiPageJumplist.activate(location.hash);
		}
	}
};

// ------
// Public
// ------

const layout = () => {
	header();
	navigation();
	footer();
	search();
	emergency();
	social();

	// Sprungliste (hinzugefügt einer Seite)
	pageJumplist();
};

// Export
export default layout;
